import { InputAdornment } from "@mui/material";
import React from "react";
import { CalendarIcon } from "@mui/x-date-pickers";

import Button from "../button/Button";
import { Close } from "../svg/svgImageList";

interface CloseAdornmentProps {
  onChange: (date: Date | null | undefined) => void;
  isEnabled: boolean;
}

export function CloseAdornment(props: CloseAdornmentProps) {
  if (!props.isEnabled) {
    return null;
  }

  return (
    <InputAdornment position="end">
      <span className="clear-end-adornment">
        <Button
          id="clear-date"
          onClick={() => {
            props.onChange(null);
          }}
          icon={{
            svg: Close,
            width: 11,
            height: 11,
          }}
        />
      </span>
    </InputAdornment>
  );
}

interface CalendarAdornmentProps {
  onClick: () => void;
}

export function CalendarAdornment(props: CalendarAdornmentProps) {
  return (
    <InputAdornment position="start">
      <span className="calendar-end-adornment" onClick={props.onClick}>
        <CalendarIcon />
      </span>
    </InputAdornment>
  );
}
